module.exports = __webpack_public_path__ + "img/voltaje_b.23ab2e20.svg";